import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import { IEntityMapping, IPropertyMapping } from '@/typings/import';

export default class TransportationPermissionMapping
  implements IEntityMapping<TransportationPermission> {
  static readonly NON_ENTITY_MAPPINGS = [ 'passengerName', 'passengerExternalId', 'passengerSsn', 'creationColumn' ];
  static readonly COSTCENTER_MAPPING = 'costCenter';
  static readonly ENTITY_CREATION_MAPPING = 'creationColumn';

  passengerName: IPropertyMapping = {
    propertyName: 'passengerName',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  passengerExternalId: IPropertyMapping = {
    propertyName: 'passengerExternalId',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  passengerSsn: IPropertyMapping = {
    propertyName: 'passengerSsn',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  creationColumn: IPropertyMapping = {
    propertyName: 'creationColumn',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  name: IPropertyMapping = {
    propertyName: 'name',
    propertyType: 'string | null',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  isDraft: IPropertyMapping = {
    propertyName: 'isDraft',
    propertyType: 'boolean',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  costCenter: IPropertyMapping = {
    propertyName: 'costCenter',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  child: IPropertyMapping = {
    propertyName: 'child',
    propertyType: 'boolean',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  passengerId: IPropertyMapping = {
    propertyName: 'passengerId',
    propertyType: 'number',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  tripDestinations: IPropertyMapping = {
    propertyName: 'tripDestinations',
    propertyType: 'number',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  deductiblePayment: IPropertyMapping = {
    propertyName: 'deductiblePayment',
    propertyType: 'number',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  deductibleType: IPropertyMapping = {
    propertyName: 'deductibleType',
    propertyType: 'number',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  fixedDeductible: IPropertyMapping = {
    propertyName: 'fixedDeductible',
    propertyType: 'number | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  distanceLimit: IPropertyMapping = {
    propertyName: 'distanceLimit',
    propertyType: 'number | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  initialQuota: IPropertyMapping = {
    propertyName: 'initialQuota',
    propertyType: 'number',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  initialExpressQuota: IPropertyMapping = {
    propertyName: 'initialExpressQuota',
    propertyType: 'number',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  remainingQuota: IPropertyMapping = {
    propertyName: 'remainingQuota',
    propertyType: 'number | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  quotaTime: IPropertyMapping = {
    propertyName: 'quotaTime',
    propertyType: 'number',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  startDate: IPropertyMapping = {
    propertyName: 'startDate',
    propertyType: 'string',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  endDate: IPropertyMapping = {
    propertyName: 'endDate',
    propertyType: 'string',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  note: IPropertyMapping = {
    propertyName: 'note',
    propertyType: 'string | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  accountKey: IPropertyMapping = {
    propertyName: 'accountKey',
    propertyType: 'string | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  priceCode: IPropertyMapping = {
    propertyName: 'priceCode',
    propertyType: 'string | null',
    required: false,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };
  tripDirection: IPropertyMapping = {
    propertyName: 'tripDirection',
    propertyType: 'number',
    required: true,
    static: null,
    cell: null,
    allowStatic: true,
    useStatic: false
  };

  // TODO: Extras. Probably needs a separate mapper 
  // extras?: TransportationPermissionExtra[];

  constructor(mapping?: IEntityMapping<TransportationPermission>) {
    if (mapping) {
      Object.keys(mapping).forEach(k => this[k] = mapping[k]);
    }
  }

  get props(): IPropertyMapping[] {
    return Object.keys(this).map(k => this[k]);
  }

  isValid(): boolean {
    throw new Error('Method not implemented.');
  }

  updateSearchProperty(searchProperty: IPropertyMapping) {
    let updatedProperty: IPropertyMapping | null = null;
    switch (searchProperty.propertyName) {
      case 'name':
        updatedProperty = this.passengerName;
        break;
      case 'externalId':
        updatedProperty = this.passengerExternalId;
        break;
      case 'ssn':
        updatedProperty = this.passengerSsn;
        break;
    }
    if (!updatedProperty) {
      return;
    }

    updatedProperty.cell = searchProperty.cell;
    updatedProperty.static = searchProperty.static;
    updatedProperty.useStatic = searchProperty.useStatic;
  }
}
